export const BUSINESS = {
  name: "Magical Cleaning Team",
  phoneDisplay: "(437) 992-4594",
  phoneHref: "+14379924594",
  email: "simkhadacanada@gmail.com",
  areas: ["Kitchener", "Waterloo", "Cambridge"],
  hours: "Every day · 7am – 11pm",
};

export const IMAGES = {
  logo: "https://static.prod-images.emergentagent.com/jobs/78042526-87bd-4801-afc6-14d6c855a9f1/images/142bc54383b7ca27404a4ac9f29e63a081b0b676a62bad9147715a19d371d28d.png",
  logoWhite: "https://static.prod-images.emergentagent.com/jobs/78042526-87bd-4801-afc6-14d6c855a9f1/images/c76f652a53d80e21604f27f257ff073360580d4e5bd8fea67c68884bb25ff24b.png",
  heroLiving: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  livingAlt: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  kitchen: "https://images.pexels.com/photos/5591851/pexels-photo-5591851.jpeg?auto=compress&cs=tinysrgb&w=1400",
  kitchenGloves: "https://images.pexels.com/photos/5591908/pexels-photo-5591908.jpeg?auto=compress&cs=tinysrgb&w=1400",
  office: "https://images.pexels.com/photos/1128207/pexels-photo-1128207.jpeg?auto=compress&cs=tinysrgb&w=1400",
  team: "https://images.pexels.com/photos/9462761/pexels-photo-9462761.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const SERVICES = [
  {
    id: "house",
    num: "01",
    title: "House Cleaning",
    tag: "Weekly · Bi-weekly · Monthly",
    desc: "Consistent, top-to-bottom cleaning that keeps your home effortlessly fresh — dusting, floors, kitchen, and bathrooms, every visit.",
    image: IMAGES.kitchen,
  },
  {
    id: "deep",
    num: "02",
    title: "Deep Cleaning",
    tag: "The full reset",
    desc: "A meticulous, detail-obsessed clean of every surface, baseboard, and hidden corner. Perfect for seasonal refreshes and neglected spaces.",
    image: IMAGES.livingAlt,
  },
  {
    id: "move",
    num: "03",
    title: "Move-in / Move-out Cleaning",
    tag: "Deposit-ready results",
    desc: "Leaving or arriving, we hand over a spotless space — inside cabinets, appliances, and closets included, ready for inspection.",
    image: IMAGES.kitchenGloves,
  },
  {
    id: "office",
    num: "04",
    title: "Office Cleaning",
    tag: "After-hours available",
    desc: "Professional workspace cleaning that keeps desks, common areas, and washrooms pristine — scheduled around your business.",
    image: IMAGES.office,
  },
];

export const PRICING = [
  { id: "standard", name: "Standard Clean", price: "129", unit: "per visit", best: false, features: ["Up to 2 bed / 1 bath", "Kitchen & bathrooms", "Dusting & vacuuming", "Floors mopped"] },
  { id: "deep", name: "Deep Clean", price: "249", unit: "per visit", best: true, features: ["Everything in Standard", "Baseboards & vents", "Inside appliances", "Detailed scrubbing"] },
  { id: "moveout", name: "Move-out Clean", price: "299", unit: "per visit", best: false, features: ["Full property clean", "Inside cabinets & closets", "Appliance interiors", "Inspection-ready"] },
];

export const TESTIMONIALS = [
  { quote: "Came home to a spotless place. The team was punctual, friendly and unbelievably thorough.", name: "Sarah M.", city: "Waterloo" },
  { quote: "Best move-out clean I've had — got my full deposit back. Highly recommend to anyone in Kitchener.", name: "David L.", city: "Kitchener" },
  { quote: "Our office has never looked better. Reliable every single week, no follow-ups needed.", name: "Priya R.", city: "Cambridge" },
];

export const CHAPTERS = [
  { num: "01", title: "Reliable, always", body: "Same trusted team, on time, every visit. No surprises — just a spotless space when you walk in." },
  { num: "02", title: "Detail obsessed", body: "We clean the corners nobody sees. A checklist for every room means nothing gets missed." },
  { num: "03", title: "Local & friendly", body: "Proudly serving Kitchener, Waterloo & Cambridge — a neighbourhood team you'll actually enjoy having around." },
];

export const CITIES = [
  {
    slug: "kitchener",
    name: "Kitchener",
    title: "Cleaning Services Kitchener | House & Deep Cleaning",
    metaDesc:
      "Affordable house cleaning, deep cleaning, move-out cleaning & office cleaning in Kitchener, ON. Trusted local cleaners. 20% off your first clean — get a free quote today.",
    intro:
      "Magical Cleaning Team is Kitchener's friendly, reliable choice for spotless homes and offices. From busy family homes near Fairview to condos downtown, we deliver a meticulous clean every visit — so you can spend your time on what matters.",
    neighbourhoods: ["Downtown Kitchener", "Doon", "Forest Heights", "Stanley Park", "Huron Park", "Fairview"],
    stat: "Serving Kitchener homes & offices",
    image: "https://images.unsplash.com/photo-1632829882891-5047ccc421bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    testimonial: { quote: "Best cleaning service in Kitchener — punctual, thorough and lovely to deal with.", name: "David L." },
  },
  {
    slug: "waterloo",
    name: "Waterloo",
    title: "House Cleaning Waterloo | Deep & Recurring Cleaning",
    metaDesc:
      "Professional house cleaning in Waterloo, ON — recurring, deep, move-in/move-out & office cleaning. Friendly, insured local cleaners. Save 20% on your first clean.",
    intro:
      "Looking for house cleaning in Waterloo? From student rentals near the universities to family homes in Beechwood and Laurelwood, Magical Cleaning Team keeps Waterloo spaces fresh, healthy and effortlessly tidy — on a schedule that fits your life.",
    neighbourhoods: ["Uptown Waterloo", "Beechwood", "Laurelwood", "Eastbridge", "Lakeshore", "Columbia Forest"],
    stat: "Trusted by Waterloo households",
    image: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    testimonial: { quote: "Our Waterloo home has never looked better. Reliable every single week.", name: "Sarah M." },
  },
  {
    slug: "cambridge",
    name: "Cambridge",
    title: "Move-out Cleaning Cambridge | House & Office Cleaning",
    metaDesc:
      "Move-out cleaning, house cleaning, deep cleaning & office cleaning in Cambridge, ON. Deposit-ready results from friendly local pros. First clean 20% off — free quote.",
    intro:
      "Moving in or out in Cambridge? Magical Cleaning Team delivers deposit-ready move-out cleans and detailed home cleaning across Galt, Preston and Hespeler. Inspection-ready results, every time — backed by a team that genuinely cares.",
    neighbourhoods: ["Galt", "Preston", "Hespeler", "Blair", "West Galt", "East Side"],
    stat: "Cambridge's move-out clean experts",
    image: "https://images.pexels.com/photos/5591851/pexels-photo-5591851.jpeg?auto=compress&cs=tinysrgb&w=1400",
    testimonial: { quote: "Got my full deposit back after their move-out clean in Cambridge. Highly recommend.", name: "Priya R." },
  },
];


export const FAQS = [
  {
    q: "How much does a cleaning service cost?",
    a: "Our standard clean starts at $129, deep cleans from $249 and move-out cleans from $299. Final pricing depends on your home's size and condition — we always give a free, no-obligation quote upfront with no hidden fees.",
  },
  {
    q: "Do I need to provide cleaning supplies or equipment?",
    a: "No — we bring everything. All professional supplies and equipment are included, and we use eco-friendly, non-toxic products that are safe for your family and pets.",
  },
  {
    q: "Which areas do you serve?",
    a: "We proudly serve Kitchener, Waterloo and Cambridge, along with surrounding Tri-Cities neighbourhoods for both homes and businesses.",
  },
  {
    q: "Do you offer a first-time customer discount?",
    a: "Yes! New customers save 20% on their first clean. Just mention it when you request your free quote.",
  },
  {
    q: "Are you insured and are your cleaners vetted?",
    a: "Absolutely. Every cleaner is background-checked and fully insured, so you can feel completely comfortable having us in your home or office.",
  },
  {
    q: "Do you clean offices and commercial spaces?",
    a: "Yes — we offer professional office and commercial cleaning with flexible after-hours scheduling so we never disrupt your business.",
  },
  {
    q: "What's the difference between a standard clean and a deep clean?",
    a: "A standard clean covers everyday upkeep — dusting, floors, kitchen and bathrooms. A deep clean is a full reset that also includes baseboards, vents, inside appliances, grout scrubbing and the details that are easy to miss.",
  },
  {
    q: "How do I book a cleaning?",
    a: "Simply request a free quote online or call us at (437) 992-4594. We'll confirm your details, give you a price, and schedule a time that works for you.",
  },
];
